var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileBadge(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7091 9V6.66407M16.7091 6.66407C16.7098 6.39999 16.6581 6.1384 16.5571 5.8944C16.4562 5.65039 16.3079 5.4288 16.1208 5.2424L13.1308 2.2524C12.9444 2.06534 12.7228 1.91703 12.4788 1.81606C12.2348 1.71508 11.9732 1.66342 11.7091 1.66407M16.7091 6.66407L12.5425 6.66406C12.3214 6.66406 11.9532 6.41998 11.9532 6.41998C11.9532 6.41998 11.7091 6.05174 11.7091 5.83073L11.7091 1.66407M11.7091 1.66407H5.04245C4.60042 1.66407 4.1765 1.83966 3.86394 2.15222C3.55138 2.46478 3.37578 2.88871 3.37578 3.33074L3.37505 16.8425C3.37502 17.3948 3.82275 17.8426 4.37505 17.8426H7.5",
    stroke: "#67768E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79688 4.5C7.04777 4.5 7.2491 4.5 8.5 4.5",
    stroke: "#67768E",
    strokeWidth: 1.15104,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.79688 7H7.5",
    stroke: "#67768E",
    strokeWidth: 1.15104,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4679 14.9007L15.1497 18.7375C15.1573 18.7827 15.151 18.8291 15.1315 18.8706C15.1121 18.9121 15.0804 18.9466 15.0408 18.9696C15.0011 18.9926 14.9554 19.003 14.9097 18.9993C14.8641 18.9956 14.8206 18.9781 14.7852 18.949L13.1741 17.7398C13.0964 17.6817 13.0019 17.6503 12.9048 17.6503C12.8077 17.6503 12.7132 17.6817 12.6355 17.7398L11.0217 18.9486C10.9863 18.9775 10.9429 18.9951 10.8973 18.9987C10.8517 19.0024 10.806 18.9921 10.7664 18.9692C10.7268 18.9463 10.6951 18.9118 10.6756 18.8704C10.6561 18.829 10.6497 18.7826 10.6572 18.7375L11.3385 14.9007M15.6033 12.7001C15.6033 14.1913 14.3944 15.4002 12.9032 15.4002C11.412 15.4002 10.2031 14.1913 10.2031 12.7001C10.2031 11.2089 11.412 10 12.9032 10C14.3944 10 15.6033 11.2089 15.6033 12.7001Z",
    stroke: "#67768E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBadge);
export default __webpack_public_path__ + "static/media/fileBadge.a89479c809ab0d412accd93c7e9ab5e7.svg";
export { ForwardRef as ReactComponent };